export const deptmentList = [
  { id: 1, label: "Lab" },
  { id: 2, label: "Geotech" },
  { id: 3, label: "DGT" },
  { id: 4, label: "NDT" },
  { id: 5, label: "Procurement" },
  { id: 6, label: "Account" },
  { id: 7, label: "HR" },
  { id: 8, label: "Admin" },
  { id: 9, label: "Store" },
  { id: 10, label: "Management" },
];
